






































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { hmToDate, dateToHm } from "@/utility/PartografHelper";

@Component({ components: { VCDateTimePicker } })
export default class SectionBayi extends Vue {
  @Prop({ required: true }) value!: any;
  local: any = {};

  get jamBayiLahir() {
    return hmToDate(this.local.bayi_lahir_jam);
  }

  setJamBayiLahir(val: any) {
    this.$set(this.local, "bayi_lahir_jam", dateToHm(val));
  }

  normalOpts = ["Mengeringkan", "Menghangatkan", "Rangsangan taktil", "Bungkus bayi dan tempatkan di sisi ibu"];
  aspiksiaOpts = ["Mengeringkan", "Bebaskan jalan napas", "Rangsangan taktil", "Menghangatkan", "Bungkus bayi dan tempatkan di sisi ibu"];

  @Watch("value", { immediate: true, deep: true })
  onValueChange(v: any) {
    const vStr = JSON.stringify(v || {});
    if (JSON.stringify(this.local) === vStr) return;
    this.local = JSON.parse(vStr);
    if (!Array.isArray(this.local.tindakan)) this.local.tindakan = [];
    if (!Array.isArray(this.local.aspiksia_tindakan)) this.local.aspiksia_tindakan = [];
    if (!Array.isArray(this.local.hipotermi_tindakan) || this.local.hipotermi_tindakan.length < 3) {
      this.local.hipotermi_tindakan = ["", "", ""];
    }
  }

  @Watch("local", { deep: true })
  emitInput(v: any) {
    this.$emit("input", v);
  }
}
